import { Pipe, PipeTransform } from '@angular/core';
import type { AppLocale } from '../../services/locale/locale.service';
import { localizedName } from '../../utils/locale.utils';

/**
 * The `name` / `name_da` pair the backend sends for translatable names (document types and
 * subtypes, control templates, …), in the UI language. Pure: pass the locale signal's value so
 * the pipe re-runs on a language switch.
 *
 * Usage: `cat | localizedName: locale()`
 */
@Pipe({ name: 'localizedName' })
export class LocalizedNamePipe implements PipeTransform {
  transform(
    item: { name?: string | null; name_da?: string | null } | null | undefined,
    locale: AppLocale | string
  ): string {
    return item ? localizedName(item, locale) : '';
  }
}
